"use strict";

require("core-js/modules/es.object.define-property.js");

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.opt = void 0;

require("element-ui/lib/theme-chalk/src/base.css");

require("element-ui/lib/theme-chalk/src/tooltip.css");

var _tooltip2 = _interopRequireDefault(require("element-ui/lib/tooltip"));

require("sk-ui/lib/theme-chalk/src/base.css");

require("sk-ui/lib/theme-chalk/src/sk-loading.css");

var _loading = _interopRequireDefault(require("sk-ui/lib/loading"));

require("sk-ui/lib/theme-chalk/src/sk-dialog.css");

var _dialog = _interopRequireDefault(require("sk-ui/lib/dialog"));

require("element-ui/lib/theme-chalk/src/notification.css");

var _notification2 = _interopRequireDefault(require("element-ui/lib/notification"));

require("element-ui/lib/theme-chalk/src/message-box.css");

var _messageBox2 = _interopRequireDefault(require("element-ui/lib/message-box"));

require("sk-ui/lib/theme-chalk/src/sk-prompt-pws.css");

var _promptPws = _interopRequireDefault(require("sk-ui/lib/prompt-pws"));

require("core-js/modules/es.array.for-each.js");

require("core-js/modules/web.dom-collections.for-each.js");

require("core-js/modules/es.object.keys.js");

require("core-js/modules/es.array.filter.js");

var _locale = _interopRequireDefault(require("element-ui/lib/locale"));

var _locale2 = _interopRequireDefault(require("sk-ui/lib/locale"));

require("sk-web-framework/utils/validate");

require("sk-web-framework/utils/loadSvgIcon");

var filters = _interopRequireWildcard(require("sk-web-framework/filters"));

var _plugins = _interopRequireDefault(require("sk-web-framework/plugins"));

require("normalize.css/normalize.css");

require("sk-web-framework/assets/styles/index.css");

var _router = _interopRequireDefault(require("sk-web-framework/router"));

var _vue = _interopRequireDefault(require("vue"));

var _App = _interopRequireDefault(require("./App"));

var _lang = _interopRequireDefault(require("@/lang"));

var _store = _interopRequireDefault(require("@/store"));

// 注册dialog
// 全局过滤器，如日期格式化
// global css
// A modern alternative to CSS resets
// if (process.env.NODE_ENV === 'unit') {
//   require('element-ui/lib/theme-chalk/src/index.css')
//   require('sk-ui/lib/theme-chalk/src/index.css')
//   require('sk-web-framework/mock')
// }
// 防止有落掉的promise 异常处理
window.addEventListener('unhandledrejection', function (e) {
  e.preventDefault();
  console.error(' promise error is ' + e);
  return true;
}); // Internationalization

_locale["default"].i18n(function (key, value) {
  return _lang["default"].t(key, value);
});

_locale2["default"].i18n(function (key, value) {
  return _lang["default"].t(key, value);
});

Object.keys(filters).forEach(function (key) {
  _vue["default"].filter(key, filters[key]);
});

_vue["default"].use(_plugins["default"]);

_vue["default"].use(_promptPws["default"]);

_vue["default"].use(_messageBox2["default"]);

_vue["default"].use(_notification2["default"]);

_vue["default"].use(_dialog["default"]);

_vue["default"].use(_loading["default"]);

_vue["default"].use(_tooltip2["default"]);

_vue["default"].config.productionTip = false;
_vue["default"].prototype.$ELEMENT = {
  btnRound: false
};
var opt = {
  router: _router["default"],
  store: _store["default"],
  i18n: _lang["default"],
  render: function render(h) {
    var _vm = this;

    return h(_App["default"]);
  },
  components: {
    App: _App["default"]
  }
};
exports.opt = opt;

if (process.env.ENV_CONFIG !== 'unit') {
  opt.el = '#app';
  var root = new _vue["default"](opt); // eslint-disable-line

  _store["default"].$root = root;
}